
import React, { useEffect, useState } from "react";
import api from '../../../components/api'
import { onlyNumberWithTwoDecimal } from '../../../components/functions'
import InputMask from 'react-input-mask'

import { useEnergiaHvacDiretaContext } from '../../../context/energiaHvacDiretaContext'
import moment from 'moment'
import { useTabelaGestao } from '../../../context/GestaoPendenciasContext'

const Modal = (props) => {


    const energia_id = props.energia_id
    const adesao_institucional_id = props.adesao_institucional_id
    const ano = props.ano

    const { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()



    const { energiaHvacExpansaoDireta_id, setEnergiaHvacExpansaoDireta_id } = useEnergiaHvacDiretaContext()


    const [marcaChillerDireta, setMarcaChillerDireta] = useState('')
    const [modeloChillerDireta, setModeloChillerDireta] = useState('')
    const [tipoEquipamento, setTipoEquipamento] = useState('')
    const [anoFabricacaoChillerDireta, setAnoFabricacaoChillerDireta] = useState('')
    const [quantidadeChillerDireta, setQuantidadeChillerDireta] = useState('')

    const [capacidadeTermicaChillerDireta, setCapacidadeTermicaChillerDireta] = useState('')
    const [potenciaEletricaChillerDireta, setPotenciaEletricaChillerDireta] = useState('')
    const [copChillerDireta, setCopChillerDireta] = useState('')
    const [fluidoRefrigeranteChillerDireta, setFluidoRefrigeranteChillerDireta] = useState('')
    const [condensacaoDireta, setCondensacaoDireta] = useState('')
    const [sistemaDireta, setSistemaDireta] = useState('')
    const [rotinaManutencaoChillerDireta, setRotinaManutencaoChillerDireta] = useState('')
    const [funcionamentoHorasDiaChillerDireta, setFuncionamentoHorasDiaChillerDireta] = useState('')
    const [funcionamentoDiasSemanaChillerDireta, setFuncionamentoDiasSemanaChillerDireta] = useState('')
    const [funcionamentoSemanasAnoChillerDireta, setFuncionamentoSemanasAnoChillerDireta] = useState('')
    const [entradaOperacaoChillerDireta, setEntradaOperacaoChillerDireta] = useState('')
    const [saidaOperacaoChillerDireta, setSaidaOperacaoChillerDireta] = useState('')

    const [resultadoFluidoRefrigerante, setResultadoFluidoRefrigerante] = useState()
    const [resultadoMarcaChiller, setResultadoMarcaChiller] = useState()


    function carregaMarcaChiller() {


        api.get(`energiaHvacChillerListaTodos`).then((result) => {

            setResultadoMarcaChiller(result.data.map((rs) =>
            
                <option value={rs.descricao}>{rs.descricao}</option>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

        

    }



    function consultaFluidoRefrigerante() {

        api.get('fluidoRefrigeranteListaTodos').then((result) => {

            //console.log(result.data)

            setResultadoFluidoRefrigerante(result.data.map((rs) =>
            
                <option key={rs.fluidoRefrigerante_id} value={rs.descricao}>{rs.descricao}</option>
            
            ))


        }).catch((err) => {

            console.log(err.response)

        })

    }


    function avisoCopChillerDireta() {

        
        if (potenciaEletricaChillerDireta != '' && capacidadeTermicaChillerDireta != '') {

            if (potenciaEletricaChillerDireta != '0') {


                var copCalculo = parseFloat(capacidadeTermicaChillerDireta.replaceAll(',', '.')) * 3.51685 / parseFloat(potenciaEletricaChillerDireta.replaceAll(',', '.'))
                //console.log(copCalculo)

                if (copCalculo.toString() != copChillerDireta.toString()) {

                    setCopChillerDireta(copCalculo.toFixed(2).toString().replaceAll('.', ','))

                    window.toastr.info(`Conforme os valores fornecidos o COP deve ser aproximadamente <b>${copCalculo.toFixed(2).toString().replaceAll('.', ',')}</b>`)

                    /*

                    window.$.confirm({
                        //icon: 'fa fa-question',
                        theme: 'material',
                        closeIcon: true,
                        animation: 'scale',
                        type: 'orange',
                        title: 'Aviso',
                        content: `Conforme os valores fornecidos o COP deve ser aproximadamente <b>${copCalculo.toFixed(2).toString().replaceAll('.', ',')}</b>`,
                        buttons: {
                            Ok: function () {
            
                                
            
                            },
                            
            
                        },
            
                    });
                    */

                }                


            }
                        

        }


    }


    
    function carregaHvacDetDireta() {

        if (energiaHvacExpansaoDireta_id) {

            api.get(`energiaHvacExpansaoDiretaListaUm/${energiaHvacExpansaoDireta_id}`).then((result) => {


                //console.log(result.data)
                
                var data = result.data[0]

                setMarcaChillerDireta(data.marcaChillerDireta)
                setModeloChillerDireta(data.modeloChillerDireta)
                setTipoEquipamento(data.tipoEquipamento)
                setAnoFabricacaoChillerDireta(data.anoFabricacaoChillerDireta == null ? '' : data.anoFabricacaoChillerDireta.toString())
                setQuantidadeChillerDireta(data.quantidadeChillerDireta == null ? '' : data.quantidadeChillerDireta.toString())

                setCapacidadeTermicaChillerDireta(data.capacidadeTermicaChillerDireta == null ? '' : data.capacidadeTermicaChillerDireta.toString())
                setPotenciaEletricaChillerDireta(data.potenciaEletricaChillerDireta == null ? '' : data.potenciaEletricaChillerDireta.toString())
                setCopChillerDireta(data.copChillerDireta == null ? '' : data.copChillerDireta.toString())
                setFluidoRefrigeranteChillerDireta(data.fluidoRefrigeranteChillerDireta)
                setCondensacaoDireta(data.condensacaoDireta)
                setSistemaDireta(data.sistemaDireta)
                setRotinaManutencaoChillerDireta(data.rotinaManutencaoChillerDireta)
                setFuncionamentoHorasDiaChillerDireta(data.funcionamentoHorasDiaChillerDireta == null ? '' : data.funcionamentoHorasDiaChillerDireta.toString())
                setFuncionamentoDiasSemanaChillerDireta(data.funcionamentoDiasSemanaChillerDireta == null ? '' : data.funcionamentoDiasSemanaChillerDireta.toString())
                setFuncionamentoSemanasAnoChillerDireta(data.funcionamentoSemanasAnoChillerDireta == null ? '' : data.funcionamentoSemanasAnoChillerDireta.toString())
                setEntradaOperacaoChillerDireta(data.entradaOperacaoChillerDireta)
                setSaidaOperacaoChillerDireta(data.saidaOperacaoChillerDireta)


            }).catch((err) => {

                console.log(err.response)

            })

        }

        
    }

    // fim

    const [listaAnos, setListaAnos] = useState()

    function carregaAnos() {

        var x_array = []

        for (var x = 1990; x <= 2030; x++) {
            
            x_array.push(x)

        }


        //console.log(x_array, 'aqui')
        setListaAnos(x_array.sort().reverse().map((ano) =>
        
            <option value={ano}>{ano}</option>
        
        ))
        

    }





    function salvaExpansaoDireta() {


        if (marcaChillerDireta == '') {

            window.toastr.error('<b>Marca do Chiller</b> não pode ficar em branco!')
            return false;

        }

        if (capacidadeTermicaChillerDireta == '') {

            window.toastr.error('<b>Capacidade Térmica</b> não pode ficar em branco!')
            return false;

        }


        if (potenciaEletricaChillerDireta == '') {

            window.toastr.error('<b>Potência Elétrica</b> não pode ficar em branco!')
            return false;

        }

        if (condensacaoDireta == '') {

            window.toastr.error('<b>Condensação</b> não pode ficar em branco!')
            return false;

        }

        if (tipoEquipamento == '') {

            window.toastr.error('<b>Tipo de Equipamento</b> não pode ficar em branco!')
            return false;

        }


        if (sistemaDireta == '') {

            window.toastr.error('<b>Sistema</b> não pode ficar em branco!')
            return false;

        }

        if (rotinaManutencaoChillerDireta == '') {

            window.toastr.error('<b>Rotina de Manutenção</b> não pode ficar em branco!')
            return false;

        }


        if (anoFabricacaoChillerDireta == '') {

            window.toastr.error('<b>Ano de Fabricação</b> não pode ficar em branco!')
            return false;

        }
        

        if (funcionamentoHorasDiaChillerDireta == '') {


            window.toastr.error('<b>Funcionamento [h/dia]</b> não pode ficar em branco!')
            return false

        } else {

            
            if (parseInt(funcionamentoHorasDiaChillerDireta) > 24) {

                window.toastr.error('<b>Funcionamento [h/dia]</b> não pode ser maior que 24!')
                return false

            }


        }


        if (funcionamentoDiasSemanaChillerDireta == '') {


            window.toastr.error('<b>Funcionamento [dias/semana]</b> não pode ficar em branco!')
            return false

        } else {

            
            if (parseInt(funcionamentoDiasSemanaChillerDireta) > 7) {

                window.toastr.error('<b>Funcionamento [dias/semana]</b> não pode ser maior que 7!')
                return false

            }


        }


        if (quantidadeChillerDireta == '') {


            window.toastr.error('<b>Quantidade</b> não pode ficar em branco!')
            return false;


        } else {

            if (quantidadeChillerDireta == '0') {

                window.toastr.error('<b>Quantidade</b> não pode ser igual a zero!')
                return false
    
            }

        }


        if (capacidadeTermicaChillerDireta == '') {

            window.toastr.error('<b>Capacidade Térmica</b> não pode ficar em branco!')
            return false;

        } else {

            if (capacidadeTermicaChillerDireta == '0') {

                window.toastr.error('<b>Capacidade Térmica</b> não pode ser igual a zero!')
                return false
    
            }

        }

        if (potenciaEletricaChillerDireta == '') {

            window.toastr.error('<b>Potência Elétrica</b> não pode ficar em branco!')
            return false;

        } else {

            if (potenciaEletricaChillerDireta == '0') {

                window.toastr.error('<b>Potência Elétrica</b> não pode ser igual a zero!')
                return false
    
            }

        }

        if (copChillerDireta != '') {

            
            if (parseFloat(copChillerDireta.replaceAll(',','.')) == 0) {

                window.toastr.error('<b>COP</b> não pode ser igual a zero!')
                return false
    
            }

        }


        if (funcionamentoSemanasAnoChillerDireta == '') {


            window.toastr.error('<b>Funcionamento [semanas/ano]</b> não pode ficar em branco!')
            return false

        } else {

            
            if (parseInt(funcionamentoSemanasAnoChillerDireta) > 52) {

                window.toastr.error('<b>Funcionamento [semanas/ano]</b> não pode ser maior que 52!')
                return false

            }


        }

        if (entradaOperacaoChillerDireta != '') {


            if (entradaOperacaoChillerDireta.indexOf('/') == -1) {

                window.toastr.error('Por favor, preencha o campo <b>Entrada em Operação</b> no formato correto: MM/AAAA!')
                return false

            } else {


                var x_array = entradaOperacaoChillerDireta.split('/')

                //console.log(x_array, 'aqui..')

                if (anoFabricacaoChillerDireta != '') {

                    if (parseInt(anoFabricacaoChillerDireta) > parseInt(x_array[1])) {

                        window.toastr.error('<b>Ano de fabricação</b> não pode ser posterior ao ano de <b>entrada em operação</b>!')
                        return false

                    }

                }
                

                if (parseInt(x_array[0]) > 12) {

                    window.toastr.error('Consta um mês inválido no campo <b>Entrada em Operação</b>!')
                    return false
    
                } else {


                    var dataEntradaChillerDiretaTemp = moment(`${x_array[1]}-${x_array[0]}-01`).format('YYYY-MM-DD')


                }


            }
            

        }


        if (saidaOperacaoChillerDireta != '') {


            if (saidaOperacaoChillerDireta.indexOf('/') == -1) {

                window.toastr.error('Por favor, preencha o campo <b>Saída de Operação</b> no formato correto: MM/AAAA!')
                return false

            } else {


                var x_array = saidaOperacaoChillerDireta.split('/')

                //console.log(x_array, 'aqui..')

                if (parseInt(x_array[0]) > 12) {

                    window.toastr.error('Consta um mês inválido no campo <b>Saída de Operação</b>!')
                    return false
    
                } else {


                    var dataSaidaChillerDiretaTemp = moment(`${x_array[1]}-${x_array[0]}-01`).format('YYYY-MM-DD')
                        //console.log(dataEntradaTemp, dataSaidaTemp)

                        //console.log('aqui..')

                    if (dataSaidaChillerDiretaTemp < dataEntradaChillerDiretaTemp) {

                        window.toastr.error('Data de saída de operação precisa ser posterior a data de entrada em operação!')
                        return false

                    }


                }


            }
            

        }


        var dataPost = {

            ano: ano,
            adesao_institucional_id: adesao_institucional_id,
            energia_id: energia_id,
            marcaChillerDireta: marcaChillerDireta,
            modeloChillerDireta: modeloChillerDireta,
            tipoEquipamento: tipoEquipamento,
            anoFabricacaoChillerDireta: anoFabricacaoChillerDireta,
            quantidadeChillerDireta: quantidadeChillerDireta,
            capacidadeTermicaChillerDireta: capacidadeTermicaChillerDireta,
            potenciaEletricaChillerDireta: potenciaEletricaChillerDireta,
            copChillerDireta: copChillerDireta,
            fluidoRefrigeranteChillerDireta: fluidoRefrigeranteChillerDireta,
            condensacaoDireta: condensacaoDireta,
            sistemaDireta: sistemaDireta,
            rotinaManutencaoChillerDireta: rotinaManutencaoChillerDireta,
            funcionamentoHorasDiaChillerDireta: funcionamentoHorasDiaChillerDireta,
            funcionamentoDiasSemanaChillerDireta: funcionamentoDiasSemanaChillerDireta,
            funcionamentoSemanasAnoChillerDireta: funcionamentoSemanasAnoChillerDireta,
            entradaOperacaoChillerDireta: entradaOperacaoChillerDireta,
            saidaOperacaoChillerDireta: saidaOperacaoChillerDireta,

        }


        //console.log(dataPost)


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {


                    if (energiaHvacExpansaoDireta_id) {

                        //console.log('put')

                        api.put(`energiaHvacExpansaoDireta/${energiaHvacExpansaoDireta_id}`, dataPost).then((result) => {
    
                            //setShow3(false)
                            //consultaHvacExpansaoDireta()
                            //window.toastr.success('Registro salvo com sucesso!')

                            window.$('#modalHVACDireta').modal('hide')
                            window.toastr.success('Registro salvo com sucesso!')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })


                    } else {

                        api.post('energiaHvacExpansaoDireta', dataPost).then((result) => {

                           
                            //setShow3(false)
                            //consultaHvacExpansaoDireta()
                            //window.toastr.success('Registro salvo com sucesso!')

                            window.$('#modalHVACDireta').modal('hide')
                            window.toastr.success('Registro salvo com sucesso!')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })

                    }

                    
                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });




    }
    


    function apagaExpansaoDireta() {



        if (energiaHvacExpansaoDireta_id) {

            window.$.confirm({
                //icon: 'fa fa-question',
                theme: 'material',
                closeIcon: true,
                animation: 'scale',
                type: 'red',
                title: 'Confirmação',
                content: 'Confirma apagar?',
                buttons: {
                    Sim: function () {
    
                        
                        api.delete(`energiaHvacExpansaoDireta/${energiaHvacExpansaoDireta_id}`).then((result) => {
    
                            //console.log(result.data)
                            //setShow3(false)
                            //consultaHvacExpansaoDireta()
                            //window.toastr.sucess('Registro apagado com sucesso')

                            window.$('#modalHVACDireta').modal('hide')
                            window.toastr.success('Registro salvo com sucesso!')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })
    
                    },
                    Cancelar: function () {
                        //$.alert('Canceled!');
                    }
    
                },
    
            });
    


        }

    }




    const handleChange = (e) => {
        e.preventDefault();
    }


    useEffect(() => {

        carregaAnos()
        consultaFluidoRefrigerante()
        carregaMarcaChiller()
        carregaHvacDetDireta()

    }, [energiaHvacExpansaoDireta_id])


    return (

        <div>

                <div className="modal fade" id="modalHVACDireta" tabindex="-1" role="dialog" aria-hidden="true" data-focus="true" >
                    <div className="modal-dialog modal-lg" role="document" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">HVAC - Sistema Central - Expansão Direta</h1>
                            </div>
                            <div className="modal-body">



                                <div className="row">


                                <div className="col-md-12" >
                                    <b>Dados básicos</b>
                                    <br/><br/>
                            </div>
                                
                                
                                <div className="col-md-6" >
                                    <div class="form-group" >
                                    
                                        <label className="control-label">Marca do Chiller *</label>
                                        <select class="form-control" value={marcaChillerDireta} onChange={event => setMarcaChillerDireta(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            <option value="Não informado">Não informado</option>
                                            {resultadoMarcaChiller}
                                            
                                        </select>
                                            
                                    </div>
                                </div>
                                <div className="col-md-6" >
                                    <div class="form-group" >
                                    
                                        <label className="control-label">Modelo do Equipamento</label>
                                        <input type="text" className="form-control" value={modeloChillerDireta} onChange={event => setModeloChillerDireta(event.target.value)} />
                                        
                                            
                                    </div>
                                </div>

                                <div className="col-md-6" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Tipo de Equipamento *</label>
                                        <select className="form-control" value={tipoEquipamento} onChange={event => setTipoEquipamento(event.target.value)}>
                                        
                                            <option value="">[Selecione]</option>
                                            <option value="Rooftop">Rooftop</option>
                                            <option value="Splitão">Splitão</option>
                                            <option value="Self Contained">Self Contained</option>
                                            <option value="VRF">VRF</option>

                                        </select>
                                            
                                    </div>
                                </div>

                                <div className="col-md-3" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Ano de Fabricação *</label>
                                        <select class="form-control" input="text" value={anoFabricacaoChillerDireta} onChange={event => setAnoFabricacaoChillerDireta(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            {listaAnos}
                                            <option value="0">Não informado</option>
                                        </select>
                                        
                                            
                                    </div>
                                </div>
                                
                                <div className="col-md-3" >
                                    <div class="form-group" >
                                    <br/>
                                        <label className="control-label">Quantidade *</label>
                                        <input class="form-control" input="text" value={quantidadeChillerDireta} onChange={event => setQuantidadeChillerDireta(event.target.value)}
                                        onCut={handleChange}
                                        onCopy={handleChange}
                                        onPaste={handleChange}
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                            }
                                        }} 
                                        />
                                            
                                    </div>
                                </div>


                                <div className="col-md-12" >
                                    <br/><br/>
                                    <b>Dados Técnicos</b>
                                    <br/><br/>
                                </div>
                                    
                                    
                                    <div className="col-md-4" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Capacidade Térmica * [TR]</label>
                                            <input class="form-control" input="text" value={capacidadeTermicaChillerDireta} onChange={event => setCapacidadeTermicaChillerDireta(event.target.value)} onBlur={() => avisoCopChillerDireta()}
                                            onKeyPress={(e)=>onlyNumberWithTwoDecimal(e)}
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-4" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Potência Elétrica * [kW]</label>
                                            <input class="form-control" input="text" value={potenciaEletricaChillerDireta} onChange={event => setPotenciaEletricaChillerDireta(event.target.value)} onBlur={() => avisoCopChillerDireta()}
                                            onKeyPress={(e)=>onlyNumberWithTwoDecimal(e)}
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-4" >
                                        <div class="form-group" >
                                            
                                            <label className="control-label">COP [W/W]</label>
                                            <input class="form-control" input="text" value={copChillerDireta} onChange={event => setCopChillerDireta(event.target.value)}
                                            onKeyPress={(e)=>onlyNumberWithTwoDecimal(e)}
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">Fluído Refrigerante</label>
                                            <select class="form-control" value={fluidoRefrigeranteChillerDireta} onChange={event => setFluidoRefrigeranteChillerDireta(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                {resultadoFluidoRefrigerante}
                                            </select>
                                                
                                        </div>
                                    </div>

                                    
                                    <div className="col-md-4" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">Condensação *</label>
                                            <select class="form-control"  value={condensacaoDireta} onChange={event => setCondensacaoDireta(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                <option value="Água">Água</option>
                                                <option value="Ar">Ar</option>
                                                
                                            </select>
                                                
                                        </div>
                                    </div>
                                    


                                    


                                    <div className="col-md-12" >
                                        <br/><br/>
                                        <b>Dados Operacionais</b>
                                        <br/><br/>
                                    </div>
                                        
                                        
                                        <div className="col-md-6" >
                                            <div class="form-group" >

                                            <label className="control-label">

                                                <span class="wrapper2">
                                                Sistema *
                                                    <div class="tooltip">
                                                    Equipamentos do mesmo sistema devem receber a mesma numeração.




                                                    </div>
                                                </span>

                                            </label>
                                            
                                                
                                                <select class="form-control"  value={sistemaDireta} onChange={event => setSistemaDireta(event.target.value)}>
                                                    <option value="">[Selecione]</option>
                                                    <option value="#01">#01</option>
                                                    <option value="#02">#02</option>
                                                    <option value="#03">#03</option>
                                                    <option value="#04">#04</option>
                                                    <option value="#05">#05</option>
                                                    <option value="#06">#06</option>
                                                    <option value="#07">#07</option>
                                                    <option value="#08">#08</option>
                                                    <option value="#09">#09</option>
                                                    
                                                </select>
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-6" >
                                            <div class="form-group" >
                                            
                                                <label className="control-label">Rotina de Manutenção *</label>
                                                <select class="form-control" value={rotinaManutencaoChillerDireta} onChange={event => setRotinaManutencaoChillerDireta(event.target.value)}>
                                                    <option value="">[Selecione]</option>
                                                    <option value="Períodica Semanal">Periódica Semanal</option>
                                                    <option value="Períodica Mensal">Periódica Mensal</option>
                                                    <option value="Períodica Anual">Periódica Anual</option>
                                                    <option value="Corretiva (mediante falha)">Corretiva (mediante falha)</option>
                                                    
                                                </select>
                                                    
                                            </div>
                                        </div>

                                        <div className="col-md-4" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Funcionamento [h/dia] *</label>
                                                <input class="form-control" input="text" value={funcionamentoHorasDiaChillerDireta} onChange={event => setFuncionamentoHorasDiaChillerDireta(event.target.value)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                    }
                                                }} 
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-4" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Funcionamento [dias/semana] *</label>
                                                <input class="form-control" input="text"  value={funcionamentoDiasSemanaChillerDireta} onChange={event => setFuncionamentoDiasSemanaChillerDireta(event.target.value)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                    }
                                                }} 
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-4" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Funcionamento [semanas/ano] *</label>
                                                <input class="form-control" input="text"  value={funcionamentoSemanasAnoChillerDireta} onChange={event => setFuncionamentoSemanasAnoChillerDireta(event.target.value)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                    }
                                                }} 
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-6" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">

                                                    <span class="wrapper2">
                                                        Entrada em operação (Mês/Ano)
                                                        <div class="tooltip">
                                                        insira a data (mês e ano) quando o equipamento entrou em operação na unidade.


                                                        </div>
                                                    </span>

                                                </label>

                                                
                                                <InputMask mask="99/9999" class="form-control"  value={entradaOperacaoChillerDireta} onChange={event => setEntradaOperacaoChillerDireta(event.target.value)}  />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-6" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">

                                                    <span class="wrapper2">
                                                        Saída de operação (Mês/Ano)
                                                        <div class="tooltip">
                                                        Insira a data (mês e ano) quando o equipamento saiu de operação na unidade. Deixar em branco caso ainda esteja em operação.


                                                        </div>
                                                    </span>

                                                </label>
                                                
                                                <InputMask mask="99/9999" class="form-control"  value={saidaOperacaoChillerDireta} onChange={event => setSaidaOperacaoChillerDireta(event.target.value)} />
                                                    
                                            </div>
                                        </div>

                                

                                </div>



                            </div>
                            <div className="modal-footer">
                           
                                <button type="button" className="btn btn-danger" onClick={() => apagaExpansaoDireta()} style={{ display: energiaHvacExpansaoDireta_id ? 'table-row' : 'none'}}>Apagar</button>
                                <button type="button" className="btn btn-success" onClick={() => salvaExpansaoDireta()}>Salvar</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>


        </div>

    )

}


export default Modal